import { render } from "./BusinessAssociationsPage.vue?vue&type=template&id=3159f724"
import script from "./BusinessAssociationsPage.vue?vue&type=script&lang=js"
export * from "./BusinessAssociationsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__